import { useEffect, useState, useCallback } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Vrftable from "./vrflist";
import VisaRequestsummary from "./visaRequestSummary";

export default function VisaRequestData() {
  const location = useLocation();
  const [addOrEdit, setAddOrEdit] = useState({
    open: false, method: "", loadedValues: {}, editId: "", routeName: "",
  });

  const stableSetAddOrEdit = useCallback((updater) => {
    setAddOrEdit(updater);
  }, []);

  useEffect(() => {
    const segment = location.pathname.split("/")[3];
    if (segment === "ops-1-summary") {
      setAddOrEdit((p) => ({ ...p, open: true, method: "add", routeName: "ops1" }));
    } else if (segment === "create-vrf") {
      setAddOrEdit((p) => ({ ...p, routeName: "create-vrf" }));
    } else if (segment === "edit-draft-vrf") {
      setAddOrEdit((p) => ({ ...p, routeName: "edit-draft-vrf" }));
    } else if (segment === "Gr-desk") {
      // Handled by child route — just track routeName, don't render here
      setAddOrEdit((p) => ({ ...p, open: false, routeName: "grDesk" }));
    } else {
      setAddOrEdit((p) => ({ ...p, open: false, routeName: "" }));
    }
  }, [location.pathname]);

  // Child routes (Gr-desk, ops-1-summary, create-vrf, edit-draft-vrf) render via <Outlet>
  const isChildRoute = ["grDesk", "create-vrf", "edit-draft-vrf"].includes(addOrEdit.routeName);

  return (
    <div>
      {isChildRoute ? (
        <Outlet />
      ) : !addOrEdit.open ? (
        addOrEdit.routeName === "ops1" ? (
          <Vrftable
            titles={["S.No.", "VRF REFERENCE NO", "NATIONALITY", "CITY", "VISA PROVIDER NAME", "TOTAL VISAS", "AMOUNT PAID", "STATUS", "DOWNLOAD"]}
            setAddOrEdit={stableSetAddOrEdit}
          />
        ) : (
          <Vrftable
            titles={["S.No.", "VRF REFERENCE NO", "VRF CREATED DATE", "NATIONALITY", "CITY", "VISA PROVIDER NAME", "TOTAL VISAS", "AMOUNT PAID", "STATUS", "LAST STATUS CHANGE DATE", "DOWNLOAD"]}
            setAddOrEdit={stableSetAddOrEdit}
          />
        )
      ) : (
        <VisaRequestsummary
          titles={["S.No", "VRF REFERENCE NO", "VISA PROVIDER", "AJEER", "SPONSOR ID", "NATIONALITY", "STAMP CITY", "VISA PROFESSION", "PRIORITY OF ISSUANCE", "TOTAL VISAS", "STATUS", "FINAL VRF CONFIRMATION", "VRF APPROVED DATE", "ACTION"]}
          addOrEdit={addOrEdit}
          setAddOrEdit={stableSetAddOrEdit}
        />
      )}
    </div>
  );
}
